import { Component, OnInit, Input } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config/config.service';
import { JackpotView, JackpotserviceService } from 'src/app/services/jackpot/jackpotservice.service';
import { stringToNumber } from 'src/app/services/codeUtils';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/app/pipes/pipes.module';

@Component({
  selector: 'jackpot-counter',
  templateUrl: 'jackpot-counter.html',
  standalone: true,
  imports: [
    CommonModule,
    PipesModule
  ]
})

export class JackpotCounterComponent implements OnInit {
  @Input('vendor') vendor: string;
  @Input('gameId') gameId: number;

  public isIpad: boolean = false;
  public jackpot = {
    amount: null,
    currency: null,
    count: null,
  };
  public isMobile: boolean = false;
  private isMobileWeb: boolean = false;
  private isTimeIntervals;
  private previousValue;

  constructor(
    private config: ConfigService,
    private platform: Platform,
    private JackpotService: JackpotserviceService
  ) {
    this.isIpad = this.platform.is('ipad');
    this.isMobile = this.platform.is('capacitor');
    this.isMobileWeb = this.platform.is('mobile');
  }

  ngOnInit() {
    this.jackpot.currency = this.config.getConfig().DEFAULT_CURRENCY;
    this.getVendorData();
    this.updatePeriodically();
  }

  ngOnDestroy() {
    this.clearIntervals();
  }

  private updatePeriodically() {
    const intervalTimeSeconds = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_UPDATE_FREQUENCY) ?? 120;
    const intervalTimeMs = intervalTimeSeconds * 1000;
    this.clearIntervals();
    this.isTimeIntervals = setInterval(() => {
      this.JackpotService.removeVendorFromCache(this.vendor)
      this.getVendorData();
    }, intervalTimeMs);
  }

  private clearIntervals() {
    if (this.isTimeIntervals) {
      clearInterval(this.isTimeIntervals);
    }
  }

  getSpanSize(balance) {
    if (this.isMobile) {
      return balance < 10000000 ? '9' : '8';
    }
    if (this.isMobileWeb) {
      return balance < 10000000 ? '14' : '12';
    }
    return '16';
  }

  protected async getVendorData() {
    try {
      const jackpotResponse: [JackpotView] = await this.JackpotService.getVendorResponse(this.vendor);
      if (jackpotResponse) {
        let jackpots = [];
        jackpots = jackpotResponse.filter((value) => value?.game?.id == this.gameId);
        const maxBalanceObj = jackpots.reduce((maxObj, currentObj) => {
          return currentObj.balance > maxObj.balance ? currentObj : maxObj;
        }, jackpots[0]);
        if (maxBalanceObj) {
          // console.log("Jackpot available for ", maxBalanceObj.game.name, " for balance ", maxBalanceObj.balance)
          this.jackpot.amount = maxBalanceObj.balance;
          this.setCountdown();
        }
      }
    } catch (error) { }
  }

  setCountdown() {
    let animationInterval: any;
    const initialValue: number = this.jackpot.amount;
    const finalAmount: number = initialValue;
    const startingFactor: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_FACTOR) ?? 0.9;
    if (this.previousValue && this.previousValue > initialValue) {
      this.jackpot.count = Math.round(initialValue * startingFactor);
    } else {
      this.jackpot.count = this.previousValue ? this.previousValue : Math.round(initialValue * startingFactor);
    }
    this.previousValue = initialValue;
    const animationDuration: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_TIMING) ?? 60; // animation duration in seconds
    const numberOfUpdatesPerSecond: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_INTERVAL) ?? 15; // number of updates per second
    const numberOfUpdates: number = animationDuration * numberOfUpdatesPerSecond;
    const isBiggerAmount = this.jackpot.count < finalAmount;
    const updateAmount: number = (finalAmount - this.jackpot.count) / numberOfUpdates;
    animationInterval = setInterval(() => {
      const isCounterChange = isBiggerAmount ? (this.jackpot.count < finalAmount) : (this.jackpot.count > finalAmount);
      if (isCounterChange) {
        this.jackpot.count += updateAmount;
      } else {
        clearInterval(animationInterval);
        this.jackpot.count = finalAmount;
      }
    }, 1000 / numberOfUpdatesPerSecond);
  }
}
